import React from "react";
import { Link } from "react-router-dom";
import searchIcon from "@public/img/search.svg";
import infoSquareIcon from "@public/img/info-square.svg";
import userWavesIcon from "@public/img/user-waves.svg";
import gridIcon from "@public/img/grid.svg";
import homeIcon from "@public/img/home.svg";
import instagramIcon from "@public/img/instagram.svg";
import telegramIcon from "@public/img/telegram.svg";
import "@/styles/not-found.css";

function NotFoundNavLink(props: { label: string; href: string; icon: string }) {
  return (
    <Link to={props.href} className="not-found-page__nav-link">
      <img src={props.icon} alt="" />
      <span>{props.label}</span>
    </Link>
  );
}

function SearchForm() {
  return (
    <form action="/search" method="get" className="not-found-page__search">
      <div className="not-found-page__search-inner">
        <button type="submit" className="not-found-page__search-btn">
          <img src={searchIcon} alt="جستجو" />
        </button>
        <input
          type="text"
          name="s"
          className="not-found-page__search-input"
          placeholder="جستجو نام فیلم یا بازیگر یا IMDb ID و ..."
        />
      </div>
    </form>
  );
}

function NotFound() {
  return (
    <div role="main" className="not-found-page">
      <div className="not-found-page__wrap">
        <div className="not-found-page__inner">
          <section className="not-found-page__card">
            <p className="not-found-page__code">
              4<span className="not-found-page__code-zero">0</span>4
            </p>

            <h1 className="not-found-page__title">صفحه‌ای که دنبال آن هستی اینجا نیست...</h1>

            <nav className="not-found-page__nav">
              <NotFoundNavLink label="صفحه اصلی" href="/" icon={homeIcon} />
              <NotFoundNavLink label="دسته بندی" href="/movies" icon={gridIcon} />
              <NotFoundNavLink label="بازیگران" href="/actors" icon={userWavesIcon} />
              <NotFoundNavLink label="درباره ما" href="/about" icon={infoSquareIcon} />
            </nav>

            <SearchForm />

            <div className="not-found-page__social">
              <Link
                to="https://instagram.com"
                target="_blank"
                aria-label="اینستاگرام"
                className="not-found-page__social-link"
              >
                <img src={instagramIcon} alt="اینستاگرام" />
              </Link>
              <Link
                to="https://telegram.org"
                target="_blank"
                aria-label="تلگرام"
                className="not-found-page__social-link"
              >
                <img src={telegramIcon} alt="تلگرام" />
              </Link>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
